import { ProfileCustomValuesList } from "PFApp/components/custom_values_list";
import { ProfilePreviewHeader } from "PFApp/components/profile_preview/parts/profile_preview_header";
import { ProfileCustomValue } from "PFTypes";
import { useTranslation } from "react-i18next";

type ProfilePreviewTopSkillsProps = {
  topSkills: ProfileCustomValue[];
  profileId: number;
};

export const ProfilePreviewTopSkills = ({ topSkills, profileId }: ProfilePreviewTopSkillsProps) => {
  const { t } = useTranslation("core");

  if (topSkills.length === 0) {
    return null;
  }

  return (
    <>
      <ProfilePreviewHeader>{t("profilePreview.topSkills")}</ProfilePreviewHeader>
      <ProfileCustomValuesList
        customFieldName="skills"
        customValues={topSkills}
        profileId={profileId}
        limit={10}
      />
    </>
  );
};
